import { createFileRoute } from '@tanstack/react-router';
import { PersonalSecurityNewBackupCodesRoute } from './-route-wrappers';

export const Route = createFileRoute('/_authenticated/settings/personal/security/new_backup_codes')({
  component: PersonalSecurityNewBackupCodesRoute,
});
